export const MUTATIONS = {
  CHECK_VERSION_APP: 'CHECK_VERSION_APP'
};
export default {
  [MUTATIONS.CHECK_VERSION_APP](state, params) {
    state.version = params;
  }
};
